<div class="voyage-detail-box">
  <div class="voyage-detail-header">
    <div class="d-flex">
      <div class="voyage-detail-header-state" [ngClass]="{ 'is-coloading': isColoading }">
        <img src="assets/icons/icon_package_white.svg" *ngIf="isColoading" />
        <img src="assets/icons/icon_package_row_white.svg" *ngIf="!isColoading" />

        <span class="ml-2">{{ (isColoading ? "LABELS.COLOADING" : "LABELS.GROUPAGE") | translate }}</span>
      </div>

      <div class="voyage-detail-header-route">
        <div *ngIf="!!voyage.route?.departurePort">
          {{ voyage.route?.departurePort?.country?.description }}, {{ voyage.route?.departurePort?.code }}
          {{ routeSegment(voyage.route?.departurePort?.description) }}
        </div>

        <span class="voyage-detail-header-route-arrow"><img src="assets/icons/icon_right.svg" /></span>

        <div *ngIf="!!voyage.route?.arrivalPort">
          {{ voyage.route?.arrivalPort?.country?.description }}, {{ voyage.route?.arrivalPort?.code }}
          {{ routeSegment(voyage.route?.arrivalPort?.description) }}
        </div>

        <div class="voyage-detail-header-departure-time" *ngIf="isListItem">
          <div *ngIf="!voyage.actualDepartureTime">
            {{ voyage.estimatedDepartureTime | customDateByUtc }}
          </div>

          <div *ngIf="!!voyage.actualDepartureTime">
            {{ voyage.actualDepartureTime | customDateByUtc }}
          </div>
        </div>
      </div>
    </div>
    <div class="voyage-detail-header-quote" *ngIf="!isShipmentItem && voyage.quotesCount !== 0">
      <img src="assets/icons/icon_add_gray.svg" class="cursor-pointer mr-2" *ngIf="!isListItem" (click)="addManualQuoteOpen.emit()" />

      ({{ "LABELS.IN_QUOTE_STATUS" | translate : { number: isListItem ? voyage.quotesCount : quotesCount } }})
    </div>

    <div class="voyage-detail-header-status">
      <span class="voyage-detail-header-status-value" [ngClass]="stateBackground" *ngIf="isListItem || isShipmentItem">
        {{ statusName }}
      </span>

      <div class="btn-group change-status d-print-none" *ngIf="!isListItem && !isShipmentItem" dropdown>
        <button id="button-status" dropdownToggle type="button" class="btn btn-link dropdown-toggle">
          <span>{{ statusName }}</span>
          <span class="wrapper-icon-carret"><i class="fa fa-caret-down"></i></span>
        </button>
        <ul id="dropdown-statuses" class="dropdown-menu" role="menu" *dropdownMenu>
          <li role="menuitem" *ngFor="let item of statusItems" (click)="changeStatus.emit(item.value)">
            <span class="dropdown-item">
              {{ item.label }}
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="voyage-detail-cols">
    <ng-container
      [ngTemplateOutlet]="colItem"
      [ngTemplateOutletContext]="{ header: 'MENU.VOYAGES', body: voyageColBody, isEditable: isEditable, id: 'voyageNums', colWidth: 25 }"
    ></ng-container>
    <ng-template #voyageColBody>
      <div class="voyage-detail-col-body-item">
        <div class="voyage-detail-col-body-item-header">
          {{ "LABELS.REFERENCE_NUMBER" | translate }}
        </div>
        <div class="voyage-detail-col-body-item-value" [ngClass]="{ link: isShipmentItem }" (click)="redirectToVoyage()">
          {{ voyage.referenceNumber }}
        </div>
      </div>

      <div class="voyage-detail-col-body-item">
        <div class="voyage-detail-col-body-item-header">
          {{ "LABELS.VOYAGE_NUMBER" | translate }}
        </div>
        <div class="voyage-detail-col-body-item-value">
          {{ voyage.voyageNumber }}
        </div>
      </div>

      <div class="voyage-detail-col-body-item">
        <div class="voyage-detail-col-body-item-header">
          {{ "LABELS.VESSEL_NAME" | translate }}
        </div>
        <div class="voyage-detail-col-body-item-value">
          {{ voyage.vesselName }}
        </div>
      </div>

      <div class="voyage-detail-col-body-item" *ngIf="!isShipmentItem && !isListItem">
        <div class="voyage-detail-col-body-item-header">
          {{ "LABELS.MBL_SCAC" | translate }}
        </div>
        <div class="voyage-detail-col-body-item-value">
          {{ containers[0]?.billNumber?.carrier ? containers[0]?.billNumber?.carrier : ("LABELS.NA" | translate) }}
        </div>
      </div>
      <div class="voyage-detail-col-body-item" *ngIf="!isShipmentItem && !isListItem">
        <div class="voyage-detail-col-body-item-header">
          {{ "LABELS.MBL_NUMBER" | translate }}
        </div>
        <div class="voyage-detail-col-body-item-value">
          {{ containers[0]?.billNumber?.number ? containers[0]?.billNumber?.number : ("LABELS.NA" | translate) }}
        </div>
      </div>
    </ng-template>

    <ng-container
      [ngTemplateOutlet]="colItem"
      [ngTemplateOutletContext]="{ header: 'LABELS.DATES', body: datesColBody, isEditable: isEditable, id: 'voyageDates', colWidth: 25 }"
    ></ng-container>
    <ng-template #datesColBody>
      <div class="voyage-detail-col-body-item flex-row">
        <div class="voyage-detail-col-body-item-header">
          {{ "LABELS.CREATION_DATE" | translate }}
        </div>
        <div class="voyage-detail-col-body-item-value">
          {{ voyage?.modificationData?.createdDate | customDateByUtc }}
        </div>
      </div>

      <div class="voyage-detail-col-body-item flex-row">
        <div class="voyage-detail-col-body-item-header">
          {{ "LABELS.CUT_OFF_DATE" | translate }}
        </div>
        <div class="voyage-detail-col-body-item-value">
          {{ voyage.warehouseCutoff | customDateByUtc }}
        </div>
      </div>

      <div class="voyage-detail-col-body-item flex-row">
        <div class="voyage-detail-col-body-item-header">
          {{ "LABELS.ETD" | translate }}
        </div>
        <div class="voyage-detail-col-body-item-value">
          {{ voyage.estimatedDepartureTime | customDateByUtc }}
        </div>
      </div>

      <div class="voyage-detail-col-body-item flex-row" *ngIf="!!voyage.actualDepartureTime">
        <div class="voyage-detail-col-body-item-header">
          {{ "LABELS.ATD" | translate }}
        </div>
        <div class="voyage-detail-col-body-item-value">
          {{ voyage.actualDepartureTime | customDateByUtc }}
        </div>
      </div>

      <div class="voyage-detail-col-body-item flex-row">
        <div class="voyage-detail-col-body-item-header">
          {{ "LABELS.ETA" | translate }}
        </div>
        <div class="voyage-detail-col-body-item-value">
          {{ voyage.estimatedArrivalTime | customDateByUtc }}
        </div>
      </div>

      <div class="voyage-detail-col-body-item flex-row" *ngIf="!!voyage.actualArrivalTime">
        <div class="voyage-detail-col-body-item-header">
          {{ "LABELS.ATA" | translate }}
        </div>
        <div class="voyage-detail-col-body-item-value">
          {{ voyage.actualArrivalTime | customDateByUtc }}
        </div>
      </div>
    </ng-template>

    <ng-container
      *ngIf="!isListItem"
      [ngTemplateOutlet]="colItem"
      [ngTemplateOutletContext]="{ body: shipmentsGatheringLocationColBody, colWidth: 35 }"
    ></ng-container>
    <ng-template #shipmentsGatheringLocationColBody>
      <div class="voyage-detail-col-header">
        <h5>{{ "LABELS.SHIPMENTS_GATHERING_LOCATION" | translate }}</h5>
      </div>
      <div
        class="voyage-detail-col-body-item link"
        (click)="redirectToCfsView(voyage?.combinedPricelist?.originAgent?.id, voyage?.originContainerFreightStorage?.id)"
      >
        <div class="voyage-detail-col-body-item-value">
          <address-details
            [address]="voyage?.originContainerFreightStorage?.address"
            *ngIf="!!voyage?.originContainerFreightStorage?.address"
          ></address-details>
        </div>
      </div>
      <div class="voyage-detail-col-header">
        <h5>{{ "LABELS.DESTINATION_CFS" | translate }}</h5>
      </div>
      <div
        class="voyage-detail-col-body-item link"
        (click)="redirectToCfsView(voyage?.combinedPricelist?.destinationAgent?.id, voyage?.destinationContainerFreightStorage?.id)"
      >
        <div class="voyage-detail-col-body-item-value">
          <address-details
            [address]="voyage?.destinationContainerFreightStorage?.address"
            *ngIf="!!voyage?.destinationContainerFreightStorage?.address"
          ></address-details>
        </div>
      </div>
    </ng-template>

    <ng-container
      [ngTemplateOutlet]="colItem"
      [ngTemplateOutletContext]="{
        header: isCombinedPricing ? 'LABELS.PRICE_LIST_COMBINED' : 'LABELS.PRICE_LIST_SEPARATED',
        body: priceListColBody,
        isLastItem: !isListItem,
        colWidth: 35
      }"
    ></ng-container>
    <ng-template #priceListColBody>
      <ng-container *ngIf="isCombinedPricing">
        <div class="voyage-detail-col-body-item flex-row">
          <div class="voyage-detail-col-body-item-header">
            {{ "LABELS.ORIGIN_AGENT" | translate }}
          </div>
          <div class="voyage-detail-col-body-item-value link" (click)="redirectToPriceList(voyage.combinedPricelist?.id, true)">
            {{ voyage.combinedPricelist?.originAgent?.name }} -
            {{ voyage.combinedPricelist?.id }}
          </div>
        </div>

        <div class="voyage-detail-col-body-item flex-row">
          <div class="voyage-detail-col-body-item-header">
            {{ "LABELS.DESTINATION_AGENT" | translate }}
          </div>
          <div class="voyage-detail-col-body-item-value link" (click)="redirectToPriceList(voyage.combinedPricelist?.id, true)">
            {{ voyage.combinedPricelist?.destinationAgent?.name }} -
            {{ voyage.combinedPricelist?.id }}
          </div>
        </div>

        <div class="voyage-detail-col-body-item flex-row">
          <div class="voyage-detail-col-body-item-header">
            {{ "LABELS.FREIGHT_AGENT" | translate }}
          </div>
          <div class="voyage-detail-col-body-item-value link" (click)="redirectToPriceList(voyage.combinedPricelist?.id, true)">
            {{ voyage.combinedPricelist?.freightAgent?.name }} -
            {{ voyage.combinedPricelist?.id }}
          </div>
        </div>
      </ng-container>
    </ng-template>

    <ng-container
      *ngIf="isListItem"
      [ngTemplateOutlet]="colItem"
      [ngTemplateOutletContext]="{ body: countColBody, isEditable: false, isLastItem: true, colWidth: 15 }"
    ></ng-container>
    <ng-template #countColBody>
      <div class="voyage-detail-col-body-item" *ngIf="!isColoading">
        <div class="voyage-detail-col-body-item-header">
          {{ "MENU.SHIPMENTS" | translate }}
        </div>
        <div class="voyage-detail-col-body-item-value">{{ voyage.shipmentsCount }}</div>
        <div class="voyage-detail-col-body-item-header">
          {{ "MENU.CONTAINERS" | translate }}
        </div>
        <div class="voyage-detail-col-body-item-value">{{ voyage.containersCount }}</div>
      </div>
      <div class="voyage-detail-col-body-item" *ngIf="isColoading">
        <div class="voyage-detail-col-body-item-header">
          {{ "MENU.SHIPMENTS" | translate }}
        </div>
        <div class="voyage-detail-col-body-item-value">{{ voyage.shipmentsCount }}</div>
      </div>
    </ng-template>
  </div>

  <div *ngIf="!isShipmentItem && !isListItem">
    <voyage-totals [shipments]="allShipments" [totals]="voyageTotals" [voyageType]="voyage.voyageType"></voyage-totals>
  </div>
</div>

<ng-template
  #colItem
  let-header="header"
  let-body="body"
  let-isLastItem="isLastItem"
  let-isEditable="isEditable"
  let-id="id"
  let-colWidth="colWidth"
>
  <div class="voyage-detail-col" [ngClass]="{ 'last-item': isLastItem }" [ngStyle]="{ width: colWidth + '%' }">
    <div class="voyage-detail-col-header" *ngIf="!!header">
      <h5>{{ header | translate }}</h5>

      <span class="voyage-detail-col-header-icon" *ngIf="isEditable && !isListItem" (click)="changeModalState.emit(id)">
        <img src="assets/icons/edit_gray.svg" />
      </span>
    </div>

    <div class="voyage-detail-col-body">
      <ng-container *ngTemplateOutlet="body"></ng-container>
    </div>
  </div>
</ng-template>
